import React, {useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import DashboardHeader from '../dashboardHeader'
import DashBoardContainer from '../../../components/containers/dashboardContainer'
import HorizontalTextinput from '../../../components/horizontalTextinput'
import {
    fetchFirmApplicationStatus as fetchFirmApplication,
    updateFirmApplication
} from '../../../actions'
import {SUBMIT_FIRM_APPLICATION_ID} from '../../../store/loaders'
import { v4 as uuidv4 } from 'uuid'






const CompanyProjectDetails = (props)=>{

    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector((state=>{
        const {firmApplication,loader,firmApplicationSubmitted,hasUpdatedFirm} = state
        const {application} = firmApplication
        const {isLoading} = loader[SUBMIT_FIRM_APPLICATION_ID] || {isLoading: false}
        const {response} = firmApplicationSubmitted
        const {updateId} = hasUpdatedFirm

        return{
            application,
            isLoading,
            response,
            hasUpdatedFirm,
            updateId
        }
    }))

    const [projectName, 
        setProjectName] = useState('')
    const [clientName,
        setClientName] = useState('')

    const [newArr,
        setNewArr] = useState([])

    const [applicationDetails, setApplicationDetails] = useState({})
    const [requestId, setRequestId] = useState('')



    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    var actionLoader = apiResponse.isLoading
    const appId = props.location.state && props.location.state.application?.id





    useEffect(()=>{
        dispatch(fetchFirmApplication(appId))
    },[])

    useEffect(()=>{
        if(apiResponse.updateId === requestId && apiResponse.response?.status === 'success'){
            history.push({
                pathname: '/dashboard',
                state: applicationDetails
            })
        }
    },[apiResponse.updateId])

    useEffect(()=>{
        if(apiResponse.response?.status === 'success'){
            dispatch(fetchFirmApplication(appId))
        }
    },[apiResponse.response])

    useEffect(()=>{
        if(apiResponse.application?.id){
            setApplicationDetails({
                ...apiResponse.application
            })
        }
        if(apiResponse.application?.projects?.length > 0){
            setNewArr(apiResponse.application.projects)
        }
    },[apiResponse.application])

    const handleNewArr = ()=>{
        setNewArr([...newArr, {
            projectName,
            clientName
        }])
        setProjectName('')
        setClientName('')
    }

    const handleRemoveItem = (id)=>{
        var deletedItem 
        deletedItem = newArr.filter(function(el,index){
            return index !== id
        })
        setNewArr(deletedItem)
    }

    var displayNewArr
    if(newArr.length > 0){
        displayNewArr = newArr.map((value, id)=>{
            return(
            <div className="dashboarder-grey-contanier mt-4 mb-4">
                <div style={{width:'62%'}}>
                    <HorizontalTextinput 
                        title="Name of the project"
                        value={value.projectName || value.name}
                        disabled={true}
                    />
                </div>
                <div style={{width:'30%'}}>
                    <HorizontalTextinput 
                        value={value.clientName || value.name}
                        title="Client"/>
                </div>
                <div className="addition-container-circle">
                    <div className="addition-red-ctn mt-4" onClick={()=>handleRemoveItem(id)}>
                        <span>-</span>
                    </div>
                </div>
            </div>
            )
        })
    }

    const handleSaveForLater = ()=>{
        const reqId = uuidv4()
        setRequestId(reqId)

        var projetcsArr = []
        if(projectName !== '' && clientName !== ''){
            projetcsArr.push({
                client: clientName,
                name: projectName
            })
        }

        if(newArr.length > 0){
            newArr.map(value=>{
                projetcsArr.push({
                    client: value.clientName || value.client,
                    name: value.projectName || value.name
                })
            })
        }

        if(applicationId){
            dispatch(updateFirmApplication({
                data: {
                    ...applicationDetails,
                    projects: projetcsArr
                },
                id:applicationId,
                reqId: reqId
            }))
        }
    }

    const handleSubmit = ()=>{
        history.push({
            pathname: '/applicant/company/attachments',
            state: {
                application: applicationDetails
            }
        }
            )
        handleSaveForLater()
    }

    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/company/shareholders',
            state: {
                application: applicationDetails
            }
        })
    }
    return (
        <div>
            <DashboardHeader
                activeStep={5}
                application={applicationDetails}/>
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                middleTitle="Save for Later"
                handleSaveForLater={handleSaveForLater}
                title="Next"
                disabled={actionLoader}
                loader={actionLoader}
                >
                   <div className="d-flex w-100" style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <span className="dashboard-green-text-header">
                        Projects accomplished details
                    </span>
                    <span className="list-down-projects-text mb-4">List down major projects accomplished with in previous 5 years.</span>
                </div>
                <div className="dashboarder-grey-contanier">

                    <div style={{width:'62%'}}>
                            <HorizontalTextinput 
                                title="Name of the project"
                                handleChange={(text)=>setProjectName(text.target.value)}
                                value={projectName}
                                type="text"
                                required={true}
                                />
                        </div>
                        <div style={{width:'30%'}}>
                            <HorizontalTextinput 
                                title="Client"
                                handleChange={(text)=>setClientName(text.target.value)}
                                value={clientName}
                                type="text"
                                required={true}
                                />
                        </div>
                    <div className="addition-container-circle">
                        <div className="addition-blue-ctn mt-4" onClick={handleNewArr}>
                            <span>+</span>
                        </div>
                    </div>
                </div>
                {displayNewArr}
            </DashBoardContainer>
        </div>
    )
}

export default CompanyProjectDetails